import React from 'react';
import { motion } from 'framer-motion';
export function ProtocolSection() {
  const steps = [{
    time: 'Día 1',
    title: 'Inicio de la carga celular',
    description: 'Tu cuerpo comienza a recibir la señal correcta.'
  }, {
    time: 'Semana 4',
    title: 'Estabilización de energía y glucosa',
    description: 'Menos antojos y niveles de energía más constantes.'
  }, {
    time: 'Semana 12',
    title: 'Resultados óptimos',
    description: 'Mejoras notables en la regularidad del ciclo y salud de la piel.'
  }];
  return <section id="protocolo" className="py-20 md:py-32 bg-cream text-dark" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-5xl font-heading mb-6" data-id="element-132">
            El Camino de las{' '}
            <span className="text-green-brand" data-id="element-133">12 Semanas.</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-134">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-1 bg-pink-brand/20 md:-translate-x-1/2 rounded-full" data-id="element-135"></div>

          <div className="space-y-12 relative" data-id="element-136">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-start md:items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-137">
                {/* Content */}
                <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12 md:text-right'}`} data-id="element-138">
                  <div className="bg-white p-6 rounded-2xl shadow-lg border border-warm-gray" data-id="element-139">
                    <span className="inline-block px-3 py-1 bg-pink-brand/10 text-pink-brand font-bold rounded-full text-sm mb-3" data-id="element-140">
                      {step.time}
                    </span>
                    <h3 className="text-xl font-bold mb-2" data-id="element-141">{step.title}</h3>
                    <p className="text-gray-600" data-id="element-142">{step.description}</p>
                  </div>
                </div>

                {/* Dot */}
                <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-green-brand rounded-full border-4 border-cream -translate-x-[14px] md:-translate-x-1/2 flex items-center justify-center shadow-md z-10" data-id="element-143">
                  <div className="w-2 h-2 bg-white rounded-full" data-id="element-144"></div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-16 text-center bg-pink-brand/5 p-6 rounded-2xl border border-pink-brand/20" data-id="element-145">
          <p className="text-lg font-medium text-pink-brand" data-id="element-146">
            Nota: La constancia es el ingrediente principal del éxito
            fisiológico.
          </p>
        </motion.div>
      </div>
    </section>;
}